// @ts-check
import Axios from 'axios';
import { graphql } from 'gatsby';
import React from 'react';
import ThumbnailImageDownloadSection from '../blocks/ThumbnailImageDownloadSection';

import './DownloadImagesBlock.scss';

export const DownloadImagesBlock_REFERENCES = ['download_images.reference'];

export const query = graphql`
	fragment DownloadImagesFragment on Ozk_pageContent {
		download_images {
			heading
			download_icon {
				...AssetFragment
			}
			reference {
				...BynderImageFragment
			}
		}
	}
`;

/**
 * @typedef DownloadImagesBlockOptions
 * @property {string} heading
 * @property {import('../CSTypes').CSFile} download_icon
 * @property {import('../CSTypes').BynderImageOptions[]} [reference]
 *
 * @typedef DownloadImagesBlockProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<DownloadImagesBlockOptions>} [options]
 * 
 * 
 */
/** @type {import('~/types/React').ReactFC<DownloadImagesBlockProps>} */
const DownloadImagesBlock = ({ options }) => {
	/** @type {string | null} */
	const initial = null;
	const [iconContent, setIconContent] = React.useState(initial);

	React.useEffect(() => {
		Axios.get(options?.download_icon?.url)
			.then((resp) => setIconContent?.(resp.data))
			.catch((err) => setIconContent?.('Error:' + err));
	}, [options?.download_icon]);

	return !options ? null : (
		<div className="download-images-block container">
			<div className="download-images-header">
				<h4 className="heading" {...options.$?.heading}>{options.heading}</h4>
			</div>
			<div className="row action-row">
				{(options.reference ?? []).map((bynderImageReference, i) => (
					<ThumbnailImageDownloadSection key={i} downloadIconContent={iconContent} option={bynderImageReference} />
				))}
			</div>
		</div>
	);
};

export default DownloadImagesBlock;
